module.exports = __webpack_public_path__ + "img/1.94f7c301.jpg";